export const defaultTableRowsPerPageOptions = [5, 15, 25, 50, 100];

export const summaryRowId = 'SUMMARY_ROW';
